import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useApplicationStore = create(
  persist(
    (set, get) => ({
      // Current application being processed
      currentApplication: null,
      
      // Selected service fee option
      selectedServiceFee: null,
      
      // All user applications
      applications: [],
      
      // Set selected service fee
      setSelectedServiceFee: (serviceFee) => set({ selectedServiceFee: serviceFee }),
      
      // Set current application being processed
      setCurrentApplication: (application) => set({ currentApplication: application }),
      
      // Add new application to list
      addApplication: (application) => set((state) => ({
        applications: [application, ...state.applications],
        currentApplication: application
      })),
      
      // Update application status
      updateApplicationStatus: (applicationId, updates) => set((state) => ({
        applications: state.applications.map(app => 
          app.id === applicationId ? { ...app, ...updates } : app
        ),
        currentApplication: state.currentApplication?.id === applicationId 
          ? { ...state.currentApplication, ...updates }
          : state.currentApplication
      })),
      
      // Set all applications
      setApplications: (applications) => set({ applications }),
      
      // Clear current application
      clearCurrentApplication: () => set({ 
        currentApplication: null, 
        selectedServiceFee: null 
      }),
      
      // Clear all application data
      clearApplicationData: () => set({
        currentApplication: null,
        selectedServiceFee: null,
        applications: []
      })
    }),
    {
      name: 'application-storage',
      partialize: (state) => ({ 
        selectedServiceFee: state.selectedServiceFee,
        applications: state.applications 
      }),
    }
  )
);

export default useApplicationStore;